import { CatalogSlice } from './reducer';

export const catalogCategoriesSelector = (state: CatalogSlice) => {
    return state.catalog.categories || [];
};

export const catalogProductsSelector = (state: CatalogSlice) => {
    return state.catalog.products;
};

export const catalogProductsFlatSelector = (state: CatalogSlice) => {
    return state.catalog.productsSlice;
};

export const isCatalogEmptySelector = (state: CatalogSlice) => {
    return Object.keys(state.catalog.products || {}).length === 0;
};
